import { FC } from "react";
import { GenericTableRow } from "./generic-table";
import DraggableTableRow from "./draggable-table-row";
import { TableCell } from "@mui/material";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

type DraggableTableProps = {
  renderedRows: GenericTableRow[];
  activeRow: number | null;
  shouldAddOnHover?: boolean;
  onAddClick?: (index: number) => void;
  tableWidth?: string;
};

const DraggableTable: FC<DraggableTableProps> = (props) => {
  const { renderedRows, activeRow, shouldAddOnHover, onAddClick, tableWidth } =
    props;

  return (
    <SortableContext
      items={renderedRows.map((row) => row.item.id)}
      strategy={verticalListSortingStrategy}
    >
      {renderedRows.map((row, index) => (
        <DraggableTableRow
          key={row.item.id}
          id={row.item.id}
          activeRow={activeRow}
          index={index}
          canAddRowOnHover={shouldAddOnHover}
          onAddClick={onAddClick}
          disabled={row.item.id === "unassigned-route"}
          routeData={{
            state: row.item.state,
            availableForAnyDriver: row.item.availableForAnyDriver,
            hasNoDriver:
              !row.item.driver?.id && !row.item.availableForAnyDriver,
          }}
          tableWidth={tableWidth}
        >
          {row.values.map(({ label, value, customCSS }) => (
            <TableCell
              key={value}
              component="th"
              scope="row"
              style={customCSS}
              align={value === "notifications" ? "center" : "left"}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              {label}
            </TableCell>
          ))}
        </DraggableTableRow>
      ))}
    </SortableContext>
  );
};

export default DraggableTable;
